export default __webpack_public_path__ + "static/media/game.0c10c1c2.mp4";